module.exports = __webpack_public_path__ + "img/boy_010036.439706b0.png";